// FILE: components/rewards/RewardController.tsx
// Mount trong layout - fetch pending reward 1 lần sau khi user login, render modal nếu cần.

"use client";

import { useEffect, useState } from "react";
import { REWARD_PRESETS, type RewardType } from "./rewardPresets";
import RewardModal from "./RewardModal";

interface PendingReward {
  type: RewardType;
  amount?: number;
}

export default function RewardController() {
  const [pending, setPending] = useState<PendingReward | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked) return;
    setChecked(true);

    fetch("/api/rewards/pending")
      .then(r => r.ok ? r.json() : { pending: null })
      .then(d => {
        if (d.pending && REWARD_PRESETS[d.pending.type as RewardType]) {
          setPending(d.pending);
        }
      })
      .catch(() => {});
  }, [checked]);

  if (!pending) return null;

  const preset = REWARD_PRESETS[pending.type];
  return (
    <RewardModal
      preset={preset}
      amount={pending.amount}
      onClose={() => setPending(null)}
    />
  );
}